import PropTypes from 'prop-types';
import React from 'react';
import { useInstantSearch } from 'react-instantsearch';
import LoadingArea from '@molecules/LoadingArea';
import { H4 } from '@styled';

export const SearchState = ({ NoResultsText = () => <>No results found.</> }) => {
    const { results, status } = useInstantSearch();

    if (status === 'stalled') {
        return <LoadingArea />;
    }

    if (results.nbHits === 0) {
        return (
            <div className="pt-1rem" style={{ height: '30vh' }}>
                <H4>
                    <NoResultsText />
                </H4>
            </div>
        );
    }

    return null;
};

SearchState.propTypes = {
    NoResultsText: PropTypes.elementType,
};
